import * as React from 'react';
import { BaseModel } from './BaseModel';
import { IQuestions } from '../interfaces';

export interface IDailyFormsModelProps {
    id?: string;
    type?: 'dailyForm';
    InCompleteFormIds?: string[];
    dailyChecklist?: {
        monthYear?: string;
        datePlant?: string;
        date?: string;
        rainAmount?: string;
        userId?: string;
        plantID?: string;
        hasItRainedToday?: boolean;
        howManyInches?: string;
        isThePlantOperatingToday?: boolean;
        houseKeepingWasPerformed?: string;
        oilSpillsCleaned?: boolean;
        dustCollectorInspection?: boolean;
        replacedBagsInDustCollector?: boolean;
        cementFlyashInspected?: boolean;
        plantPropertyWasSweptToday?: boolean;
        plantPropertyWasWashedDown?: string;
        stockPipesWereWatered?: boolean;
        burnersOnTheBoilersWereChecked?: boolean;
        govtAgencyVisited?: boolean;
        immediateCorrectionNeeded?: boolean;
    };
    plantInfo?: {
        name?: string;
        zip?: string;
        country?: string;
        region?: string;
        state?: string;
        street?: string;
        address?: string;
        id?: string;
        userId?: string;
        plantID?: string;
    };
    questions?: IQuestions[];
    ImageUrls?: string[];
    deletedImages?: string[];
    UserName?: string;
    InspectionId?: string;
    PlantId?: string;
    Region?: string;
    UserId?: string;
    FlaggedQuestion?: boolean;
    InspectionUId?: string;
    PlantUID?: string;
    Date?: string;
    SignatureUrls?: string[];
    Completed?: boolean;
    Flagged?: boolean;
    CompletedBy?: string;
    DateCompleted?: string;
    FollowUpComments?: string;
    Associations?: string[];
    ReportType?: string;
    SubmittedDate?: string;
    UpdatedDate?: string;
    UpdatedBy?: string;
}

export class DailyFormsModel extends BaseModel<IDailyFormsModelProps> {
    constructor(props: IDailyFormsModelProps) {
        super(props);
    }

    static resource = 'daily-forms';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/DailyFormModel.tsx